export enum StressTestResults {    
    NoProblem = 0,
    Abnormal = 1,
    Unknown = 2
}